/**
 * Session 19a — OCPP 2.0.1 DataTransfer (CP → CSMS, outbound).
 *
 * The v2.0.1 wire shape is identical to v1.6 for the fields the
 * simulator uses: `vendorId` (required) + optional `messageId` + optional
 * `data`. The response status enum is also the same set
 * (Accepted | Rejected | UnknownMessageId | UnknownVendorId), so the
 * version-neutral `DataTransferDomain` / `DataTransferResponse` types
 * carry across unchanged. Kept as a v201-local module so the adapter
 * layer doesn't cross-import from v16.
 */
import type { DataTransferDomain, DataTransferResponse } from '@/protocol/OcppAdapter';

export function buildDataTransferRequest(req: DataTransferDomain): Record<string, unknown> {
  const wire: Record<string, unknown> = { vendorId: req.vendorId };
  if (req.messageId !== undefined) wire['messageId'] = req.messageId;
  if (req.data !== undefined) wire['data'] = req.data;
  return wire;
}

export function parseDataTransferResponse(payload: Record<string, unknown>): DataTransferResponse {
  const out: DataTransferResponse = {
    status: payload['status'] as DataTransferResponse['status'],
  };
  if (typeof payload['data'] === 'string') return { ...out, data: payload['data'] };
  return out;
}
